import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const CompanySelector = ({ companies, selectedCompany, onCompanyChange }) => {
  const companyOptions = companies?.map(company => ({
    value: company?.id,
    label: company?.name,
    description: company?.tagline
  }));

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Building2" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Viewing company</p>
              <p className="font-semibold text-foreground">{selectedCompany?.name}</p>
            </div>
          </div>
          
          <div className="w-full max-w-xs">
            <Select
              options={companyOptions}
              value={selectedCompany?.id}
              onChange={(value) => onCompanyChange(value)}
              placeholder="Switch company"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySelector;